import { filterEmpty, QueryFilter } from '@softline/core';
import { Filter } from '../types/filter';
import { FilterConfig } from '../types/filter-config';

export function toQueryFilter<T extends object>(
  filter: Filter<T> | null,
  config: FilterConfig<T>
): QueryFilter<T> | null {
  if(!filter)
    return null;

  if (filter.type === 'conditions') {
    const { uuid, filters, ...rest } = filter;
    return { ...rest, filters: filterEmpty(filters.map(o => toQueryFilter(o, config))) };
  }
  const itemConfig = config.items.find(o => o.field === filter.field);
  if(!itemConfig)
    return null;
  return itemConfig.toQueryFilter(filter as any)
}
